<template>
    <div class="xc-modal xc-modal-page">
        <div class="xc-modal-wrap">
            <div class="xc-modal-content">
                <div class="xc-modal-header">
                    <div class="xc-modal-title">详细地址</div>
                    <div
                        class="xc-modal-close"
                        @click="layerClose"
                    ></div>
                </div>
                <div class="xc-modal-body">
                    <form name="map" class="xc-form">
                        <xc-form-item label="选择区域：">
                            <input type="text" name="province" readonly v-model="address.province"
                                   class="xc-input xc-input-disabled address" placeholder="请选择省份"/>
                            <input type="text" name="city" readonly v-model="address.city"
                                   class="xc-input xc-input-disabled address" placeholder="请选择城市"/>
                            <input type="text" name="area" readonly v-model="address.area"
                                   class="xc-input xc-input-disabled address" placeholder="请选择行政区"/>
                            <input type="hidden" name="longitude" v-model="address.longitude"/>
                            <input type="hidden" name="latitude" v-model="address.latitude"/>
                        </xc-form-item>
                        <div class="xc-form-inline">
                            <xc-form-item label="请选择详细地址" required></xc-form-item>
                        </div>
                        <div class="myMap">
                            <input type="text" name="search" placeholder="请输入" id="search" class="xc-input search"/>
                            <img src="../assets/system/address.png" class="addressIcon" @click="search"/>
                            <div id="map"></div>
                            <div id="myLocation" @click="reLocate">
                                <img
                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAAeFBMVEUAAADR1uLS2OLQ1eHP1eHQ1eHV1dXQ1eH///8igNrP1eBkpuX2+fswiNz4+/7k8Ps6jt0uh9z6+vzv9vzo6/Ciyu/c4OlqquZVneJKl+He7PmWw+2z0/K+2vTg7fong9rA2/Tx9/3n8fuy0/JElN8mgtrb6/mXw+3qgYFLAAAACHRSTlMAkv3z1SsGva8wneMAAAEtSURBVDjLjZRHloMwEEQRYFuFCBI54zhz/xsOaFiAJZuuBS3e+4SuDs6iE/O9wCrPZyfnX2fm5iH/oDB32VlTlzLlX5SWl4VjJT9Qyeb/ctMjLHVPDsv5oXLm+OExFvqOxwnynGB3nxVCTuopioxvFeywuIuwKuriT1jSAOKRAD8PATSJHbtL1MMcgflyrSHvNiyuIXTWQujsBOrYgv2iufGNbg06E8sUBr7TAJUZWAGh41hFUTXqo0BhYAL9EtpI29Eu5x7CwCS0ARW0Km0QpIFNwPLw6q9aXg9MBqZo2BOt5aP0FOyGtJVSVWs3hG4v79Yabmrc2UrfvJe+sZWejxL1ddtI45e27BMg6Y22JDa5OTKvlzRGhjiAxHEmLgfiqqEtLuIapC5V4or+A4jLNZxQGx/gAAAAAElFTkSuQmCC"/>
                            </div>
                        </div>
                        <xc-form-item label="详细地址：" required>
                            <textarea name="storeAdd" v-model="address.storeAdd" class="xc-textarea"
                                      placeholder="请输入详细地址"></textarea>
                        </xc-form-item>
                    </form>
                </div>
                <div class="xc-modal-footer xc-flex-center">
                    <div class="xc-btn-group">
                        <button
                            class="xc-btn xc-btn-default"
                            @click="layerClose"
                        >取消
                        </button>
                        <button type="button" class="xc-btn xc-btn-primary" @click="select">确定</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import myLayerImport from '@/libs/myLayer';

    myLayerImport();
    import myMap from "@/libs/baiduMap"
    import myIcon from "@/assets/system/myIcon.png"

    export default {
        name: "Map",
        data() {
            return {
                address: {
                    province: "",
                    city: "",
                    area: "",
                    storeAdd: "",
                    longitude: "",
                    latitude: ""
                },
                map: null,
                marker: {},
                center: {}
            }
        },
        methods: {
            layerClose() {
                var index = parent.layer.getFrameIndex(window.name);
                parent.layer.close(index);
            },
            //重新定位
            reLocate: function () {
                this.map.centerAndZoom(this.center,10);
                // this.map.reset();
            },
            //搜索
            search() {
                var value = document.getElementsByName("search")[0].value;
                this.setPlace(value);
            },
            //定位
            setPlace(value) {
                var _this = this;
                var local, point = null;
                local = new BMap.LocalSearch(_this.map, { //智能搜索
                    onSearchComplete: fn
                });

                local.search(value);

                function fn() {
                    //如果搜索的有结果
                    if (local.getResults() != undefined) {
                        // map.clearOverlays(); //清除地图上所有覆盖物
                        if (local.getResults().getPoi(0)) {
                            point = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
                            _this.marker.setPosition(point);
                            /*_this.map.panTo(point);
                            _this.map.setZoom(18);*/
                            _this.map.centerAndZoom(point, 18)
                            _this.address.longitude = point.lng;
                            _this.address.latitude = point.lat;
                            var geoc = new BMap.Geocoder();//地址解析器
                            geoc.getLocation(point, function (rs) {
                                var addComp = rs.addressComponents;
                                _this.address.province = addComp.province;
                                _this.address.city = addComp.city;
                                _this.address.area = addComp.district;
                                _this.address.storeAdd = addComp.street + addComp.streetNumber;
                            });
                        } else {
                            _this.$message.error("未匹配到地点！");
                        }
                    } else {
                        _this.$message.error("未找到搜索结果");
                    }
                }
            },
            select: function () {
                if (!this.address.longitude) {
                    this.$message.error("请选择地址");
                    return;
                }
                parent.initAddress(this.address);
                this.layerClose();
            },
        },
        async mounted() {
            var _this = this;
            await myMap();
            //创建地图实例
            _this.map = new BMap.Map("map", {
                enableMapClick: false,
            });
            // _this.map.addControl(new BMap.NavigationControl());
            _this.map.enableScrollWheelZoom()
            var point = new BMap.Point(104.07, 30.67);
            _this.map.centerAndZoom(point, 10);
            //添加标注
            var icon = new BMap.Icon(myIcon, new BMap.Size(32, 32), {
                offset: new BMap.Size(0, 0), // 指定定位位置
                // anchor: new BMap.Size(0, 0), // 指定定位位置
                imageOffset: new BMap.Size(0, 0) // 设置图片偏移
            })
            _this.marker = new BMap.Marker(point, {icon: icon});
            //将标注添加到地图中
            _this.map.addOverlay(_this.marker);
            var geoc = new BMap.Geocoder();//地址解析器
            //获取当前城市名后的回调函数
            function myFun(result) {
                var cityName = result.name;
                geoc.getPoint(cityName, function (point) {
                    if (point) {
                        _this.center = point;
                        /* _this.address.longitude=point.lng;
                         _this.address.latitude=point.lat;*/
                        _this.map.setCenter(point);
                        _this.marker.setPosition(point);
                        geoc.getLocation(point, function (rs) {
                            var addComp = rs.addressComponents;
                            /* _this.address.province=addComp.province;
                             _this.address.city=addComp.city;
                             _this.address.area=addComp.district;
                             _this.address.storeAdd=addComp.street + addComp.streetNumber;*/
                        });
                    }
                }, cityName);
            }

            var myCity = new BMap.LocalCity();
            myCity.get(myFun);

            //为地图绑定点击事件
            _this.map.addEventListener("click", function (e) {
                console.log("点击地图")
                var p = e.point;
                _this.marker.setPosition(p);
                _this.map.panTo(p);
                _this.address.longitude = p.lng;
                _this.address.latitude = p.lat;
                geoc.getLocation(p, function (rs) {
                    var addComp = rs.addressComponents;
                    _this.address.province = addComp.province;
                    _this.address.city = addComp.city;
                    _this.address.area = addComp.district;
                    _this.address.storeAdd = addComp.street + addComp.streetNumber;
                });
            })

            var ac = new BMap.Autocomplete(    //建立一个自动完成的对象
                {
                    "input": "search",
                    "location": _this.map,
                });
            ac.addEventListener("onconfirm", function (e) {    //鼠标点击下拉列表后的事件
                var _value = e.item.value;
                var myValue = _value.province + _value.city + _value.district + _value.street + _value.business;

                _this.setPlace(myValue)
            });
        },
        created() {

        }
    }
</script>

<style lang="scss">
    .tangram-suggestion-main {
        z-index: 999999;
    }

    form[name='map'] {
        textarea {
            height: 57px;
        }
        .address {
            width: 113px;
            margin-right: 17px;
        }
        .myMap {
            overflow: hidden;
            position: relative;
            margin-bottom: 24px;
            .search {
                position: absolute;
                display: block;
                top: 10px;
                left: 8px;
                width: 373px;
                height: 32px;
                margin-right: 40px;
                z-index: 999;
                cursor: text;
            }
            .addressIcon {
                position: absolute;
                left: 342px;
                top: 13px;
                z-index: 999;
                cursor: pointer;
            }
            #map {
                width: 100%;
                height: 276px;
                background-color: #d8d8d8;
                border-radius: 8px;
                border: solid 1px #cfd5e0;
            }
            #myLocation {
                position: absolute;
                left: 13px;
                bottom: 10px;
                cursor: pointer;
            }
        }
    }
</style>
